import { api } from "./api";
import user from "./user";
import toastr from "../plugins/toastr";

const buzzTimeout = 10000;
const notifierAutoUpdateTimeout = 60000;
const notifierBlinkTimeout = 1500;
const defaultFavicon = "/favicon.ico";
const blinkFavicon = "/favicon_notify.ico";

export class notifier {
  constructor(updateFn = () => {}, autoUpdate = false) {
    this.debug = api.debug;
    this.keys = ["task", "notice"];
    this.updateFn = updateFn;

    this.buzz = {};
    this.keys.forEach((key) => {
      this[key] = {};
      this.buzz[key] = false;
    });
    this.isBlinking = false;
    this.blinkInterval = setInterval(() => this.blink(), notifierBlinkTimeout);

    //this.load();

    if (autoUpdate) {
      setInterval(() => this.load(false, true), notifierAutoUpdateTimeout);
    }

    document.addEventListener("onWSNotification", (event) => {
      let detail = event.detail || {};
      this.dispatchNotification(detail);
    });

    document.addEventListener("click", () => this.blinkEnd());
  }

  dispatchNotification(detail) {
    if (detail) {
      let notification = detail.payload || {};

      let notificationKey = null;
      if (notification.classcode === "task") {
        notificationKey = "task";
      }
      if (notification.hasOwnProperty("category")) {
        notificationKey = "notice";
      }

      this.load(notificationKey, false);
      let message = "Новое уведомление";
      if (user.id && user.id !== notification.oper) {
        switch (notificationKey) {
          case "task":
            message = "Произошли изменения в задаче: " + notification.label;
            this.buzzStart(notificationKey);
            toastr.info(message);
            this.desktopNotification("Ship-Safety", message);
            break;
          case "notice":
            message = "" + notification.text;
            this.buzzStart(notificationKey);
            toastr.info(message);
            this.desktopNotification("Ship-Safety", message);
            break;
          default:
        }
      }
    }
  }

  blink() {
    if (this.isBlinking) {
      let title = document.title;
      if (title.substr(0, 5) === "*****") {
        document.title = title.slice(6);
        this.faviconSet(defaultFavicon);
      } else {
        document.title = `***** ${title}`;
        this.faviconSet(blinkFavicon);
      }
    }
  }

  blinkEnd() {
    if (this.isBlinking) {
      this.isBlinking = false;
      let title = document.title;
      if (title.substr(0, 5) === "*****") {
        document.title = title.slice(6);
        this.faviconSet(defaultFavicon);
      }
    }
  }

  faviconClear() {
    var o = document.querySelectorAll(
      'link[rel="icon"], link[rel="shortcut icon"]'
    );
    for (var i = 0; i < o.length; i++) {
      o[i].parentNode.removeChild(o[i]);
    }
  }
  faviconSet(src) {
    this.faviconClear();
    var n = document.createElement("link");
    n.setAttribute("rel", "icon");
    n.setAttribute("href", src);
    document.querySelector("head").appendChild(n);
  }

  buzzStart(key) {
    if (key) {
      this.isBlinking = true;
      if (this.buzz[key] === true) {
        return;
      }
      this.buzz[key] = true;
      setTimeout(() => this.buzzStop(key), buzzTimeout);
      this.updateFn();
    }
  }

  buzzStop(key) {
    if (key) {
      this.buzz[key] = false;
      this.updateFn();
    }
  }

  desktopNotification(title = "", message = "") {
    if ("Notification" in window) {
      if (
        Notification.permission !== "denied" &&
        Notification.permission !== "granted"
      ) {
        Notification.requestPermission(() => {
          this.desktopNotification(title, message);
        });
      }
      if (Notification.permission === "granted") {
        let notification = new Notification(title, {
          body: message,
          icon: "/logo192.png",
        });
      }
    }
  }

  load(key = false, makeBuzz = false) {
    let loadKeys = [];
    if (key) {
      if (Array.isArray(key)) {
        loadKeys = key;
      } else {
        loadKeys = [key];
      }
    } else {
      loadKeys = this.keys;
    }
    loadKeys.forEach((key) => this.loadKey(key, makeBuzz));
  }

  async loadKey(key, makeBuzz = false) {
    let queryParams = [];
    let resultValues = {};
    let result = null;

    switch (key) {
      case "notice": //  /notice  loading
        queryParams = [];
        let noticeCategories = ["notice", "interfere"];
        let noticeAlarmOn = ["notice", "interfere"];
        noticeCategories.forEach((key) => {
          queryParams.push({
            key,
            path: "/api/v1/notice/count",
            payload: {
              search: [
                {
                  field: "userid",
                  compare: "EQL",
                  value: user.id || 0,
                },
                {
                  field: "category",
                  compare: "EQL",
                  value: key,
                },
                {
                  field: "status",
                  valarr: [0, 1],
                },
              ],
            },
          });
        });

        resultValues = {};
        result = await api.qa("/run", queryParams);
        if (result && Array.isArray(result)) {
          result.forEach((resultItem) => {
            let count = resultItem.payload[0].count || 0;
            resultValues[resultItem.key] = count;
            if (
              makeBuzz &&
              noticeAlarmOn.includes(resultItem.key) &&
              resultValues[resultItem.key] > (this[key][resultItem.key] || 0)
            ) {
              this.buzzStart("notice");
            }
          });
        }
        this[key] = resultValues;
        if (this.debug) console.log("NOTIFIER upd: ", key, this[key]);
        this.updateFn();

        break;

      case "task": //  /task loading
        queryParams = [];
        let taskStates = ["enabled", "expired", "planned", "completed"];
        let taskAlarmOn = ["enabled", "planned"];
        taskStates.forEach((key) => {
          queryParams.push({
            key,
            path: "/api/v1/task/count",
            payload: {
              filter: {
                executor:
                  user.staffId || "00000000-0000-4000-8000-000000000000",
                statecode: key,
              },
            },
          });
        });

        resultValues = {};
        result = await api.qa("/run", queryParams);
        if (result && Array.isArray(result)) {
          result.forEach((resultItem) => {
            let count = resultItem.payload[0].count || 0;
            resultValues[resultItem.key] = count;
            if (
              makeBuzz &&
              taskAlarmOn.includes(resultItem.key) &&
              resultValues[resultItem.key] > (this[key][resultItem.key] || 0)
            ) {
              this.buzzStart("task");
            }
          });
        }
        this[key] = resultValues;
        if (this.debug) console.log("NOTIFIER upd: ", key, this[key]);
        this.updateFn();

        break;
      default:
    }
  }
}
